import { render, staticRenderFns } from "./IpoFundLists.vue?vue&type=template&id=7380a9b3"
import script from "./IpoFundLists.vue?vue&type=script&lang=js"
export * from "./IpoFundLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports